import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Stepper from "./stepper"
import configData from "../../config.json"
import saveLead from "../../Config/GlobalFunctions"

function StudentInfo() {
  const [loading, setLoading] = useState(false)
  const [continueStep, setContinueStep] = useState(false)
  const [data, setData] = useState(JSON.parse(localStorage.getItem('info')))
  const [resume, setResume] = useState(JSON.parse(sessionStorage.getItem('resume')))

  useEffect(() => {
    const data = JSON.parse(sessionStorage.getItem('lead'))
    data.FECHA_INGRESO = ''
    data.ETAPA = 'Creación de estudiante SIS'
    data.M18COD = resume.resumen.m18COD
    data.M19COD = resume.resumen.m19COD
    data.M12CAR = resume.student.carnet
    sessionStorage.setItem('lead', JSON.stringify(data))
    saveLead()

  }, [])


  return (
    <div>
      <Stepper step="4"></Stepper>
      <section className="text-center container-fluid">
        <div className="row">
          <div className="offset-lg-4 col-lg-4 mt-2  col-sm-12">
            <div className="col-12">
              <h2 className="text-red">{data.name} {data.firstName} {data.secondName},</h2><br />
              <h3>Listo tu proceso de prematrícula para la carrera</h3><br />
              <h2 className="bg-black text-white">{resume.info.careerDescription}</h2><br />
              <h3 className="text-red">{configData.SloganText}</h3><br />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="offset-lg-4 col-lg-4 mb-2 col-sm-12">
            <div className="col-12 pt-1 pb-3">
              <a href={resume.urlCV} className="btn btn-green btn-lg">Continuar</a>
            </div>
            <div className="col-12">
              <h5>Continuá el proceso en el Campus Virtual para elegir tus materias y finalizar tu matrícula.<br /></h5>
              <h5 className="text-red">* Matrícula sujeta a validación.</h5>
              <h5><a href={configData.INFO_LINKS.VIDEO_MATRICULA} target="_blank">Ver video ¿Cómo matricular en línea?</a></h5>
            </div>
          </div>
        </div>
        <div className="row mt-5">
          <div className="offset-lg-4 col-lg-4 mb-4 col-sm-12">
            <div className="col-12">
              <h5 className="">Financiamiento<br /></h5>
              <a href={configData.INFO_LINKS.FINANCIAMIENTO} className="btn btn-black" target="_blank">Conversar con asesor</a>
              <h6 className="">Contamos con diferentes alternativas de financiamiento a las que podés acceder para iniciar o continuar tus estudios en la ULatina.<br /></h6>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="offset-lg-4 col-lg-4 mb-4 col-sm-12">
            <div className="col-12">
              <h5 className="">Convalidaciones<br /></h5>
              <a href={configData.INFO_LINKS.CONVALIDACION} className="btn btn-black" target="_blank">Conversar con asesor</a>              
              <h6 className="">Te brindamos el apoyo para un proceso rápido, sin complicaciones y en menos de 24 horas.<br /></h6>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default StudentInfo